import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreLabel?: string;
  moreTo?: string;
}

export default function SectionHeading({ title, subtitle, moreLabel, moreTo }: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6">
      <div className="flex items-center gap-3 min-w-0">
        <span className="w-1 h-6 rounded-full bg-accent-500 shrink-0"></span>
        <div className="min-w-0">
          <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950 truncate">
            {title}
          </h2>
          {subtitle && <p className="text-xs md:text-sm text-foreground-500 mt-0.5">{subtitle}</p>}
        </div>
      </div>
      {moreLabel && moreTo && (
        <Link
          to={moreTo}
          className="shrink-0 inline-flex items-center gap-1 text-xs md:text-sm text-foreground-600 hover:text-accent-400 transition-colors whitespace-nowrap"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      )}
    </div>
  );
}